/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import "./styles.scss";
import { forwardRef } from "react";
import Select, { components } from "react-select";
import { ARROW_DOWN } from "@blueprintjs/core/lib/esm/common/keys";
import ArrowDown from "../../../assets/icons/arrow-down.svg";

const customStyles = {
  dropdownIndicator: (base, state) => ({
    ...base,
    color: "#0083E5", // Custom colour
    transition: "all .2s ease",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
  }),
  option: (provided, state) => ({
    ...provided,
    borderBottom: "1px dotted pink",
    color: state.isSelected ? "white" : "black",
    backgroundColor: state.isSelected ? "#0083E5" : "white",
    padding: 10,
  }),
  control: () => ({
    // none of react-select's styles are passed to <Control />
    width: (window.innerWidth / 100) * 94.2,
    height: 40,
    display: "flex",
    border: "1px solid rgb(165, 164, 164)",
    borderRadius: "7px",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";

    return { ...provided, opacity, transition };
  },
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <div
        className="close-icon"
        style={{
          backgroundImage: `url(${ArrowDown})`,
          width: "20px",
          height: "20px",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      />
    </components.DropdownIndicator>
  );
};

const AutoCompleteDropdown = forwardRef(
  ({ optionsArray, getAutocomplete, disabled, onChange }, ref) => {
    return (
      <div
        className="input-container"
        style={{ width: "100%", marginLeft: "-1.3%" }}
      >
        <Select
          options={optionsArray.map((opt) => {
            return { label: opt.fullName, value: opt };
          })}
          isMulti
          ref={ref}
          isDisabled={disabled}
          styles={customStyles}
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator,
          }}
          onInputChange={(e) => {
            getAutocomplete(e);
          }}
          onChange={onChange}
        />
      </div>
    );
  }
);

export default AutoCompleteDropdown;
